import React from 'react';
import {Nav, NavItem, UncontrolledTooltip} from 'reactstrap';
import {useSelector} from 'react-redux';
import {NavLink, useLocation} from 'react-router-dom';
import {getSystemStatus} from '../../components/StatusIcon';
import SidebarShell from './SidebarShell';

const ORG_MENU = [
    { link: '/', icon: 'fa-home', menuText: 'Home', visibleFor: ['site-guest', 'site-user', 'site-admin'] },
    { link: '/orders', icon: 'fa-clipboard-list', menuText: 'Orders', visibleFor: ['site-guest', 'site-user', 'site-admin'] },
    { link: '/equipment', icon: 'fa-server', menuText: 'Equipment', visibleFor: ['site-user', 'site-admin'], checkEquipmentStatus: true },
    { link: '/organizations/own/content', icon: 'fa-file-video', menuText: 'Content Manager', visibleFor: ['site-user', 'site-admin'] },
    { link: '/organizations/own', icon: 'fa-building', menuText: 'Organization', visibleFor: ['site-user', 'site-admin'] },
    { link: '/users', icon: 'fa-users', menuText: 'Users', visibleFor: ['site-guest', 'site-user', 'site-admin'] },
];

const OrgSidebar = ({ isOpen, toggle, organization = null }) => {
    const location = useLocation();
    const { user } = useSelector((state) => state.auth);

    const checkActive = (path) => {
        if (path === '/organizations/own/content') {
            return location.pathname === '/organizations/own/content';
        }

        if (path === '/organizations/own') {
            return location.pathname.includes(path) && !location.pathname.includes('/organizations/own/content');
        }

        if (path === '/') {
            return location.pathname === path;
        }

        return location.pathname.includes(path);
    };

    const getEquipmentStatus = () => {
        const status = getSystemStatus(organization);
        const mediablock = organization?.mediablock || {};

        return (
            <div className="ms-3" id="equipment-status-icons" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
                <span className={`fas fa-cube px-1 fa-xs icons-${status.mediablock ? 'on': 'off'}`} />
                <span className={`fas fa-server px-1 fa-xs icons-${status.bacServer ? 'on': 'off'}`} />
                <UncontrolledTooltip target="equipment-status-icons" placement="right">
                    <div className="text-start p-1">
                        <div className="fw-bold border-bottom pb-1 mb-2">
                            <span className="fas fa-cube me-2" />
                            Mediablock
                        </div>
                        <div className="mb-1">
                            <span className="text-white-50">Status:</span>{' '}
                            <span className={status.mediablock ? 'text-success' : 'text-danger'}>
                                {mediablock.status || 'Unknown'}
                            </span>
                        </div>
                        <div className="mb-1">
                            <span className="text-white-50">State:</span>{' '}
                            {mediablock.state || 'Unknown'}
                        </div>
                        <div className="mb-1">
                            <span className="text-white-50">Lamp:</span>{' '}
                            {mediablock.lamp || 'Unknown'}
                        </div>
                        <div className="mb-2">
                            <span className="text-white-50">Dowser:</span>{' '}
                            {mediablock.dowser || 'Unknown'}
                        </div>
                        <div className="fw-bold border-bottom pb-1 mb-2">
                            <span className="fas fa-server me-2" />
                            BAC Server
                        </div>
                        <div className="mb-1">
                            <span className="text-white-50">Alfred:</span>{' '}
                            <span className={organization?.bacServer?.gofilexDaemonsAlfred === 'online' ? 'text-success' : 'text-danger'}>
                                {organization?.bacServer?.gofilexDaemonsAlfred || 'Unknown'}
                            </span>
                        </div>
                        <div>
                            <span className="text-white-50">Frank:</span>{' '}
                            <span className={organization?.bacServer?.gofilexDaemonsFrank === 'online' ? 'text-success' : 'text-danger'}>
                                {organization?.bacServer?.gofilexDaemonsFrank || 'Unknown'}
                            </span>
                        </div>
                    </div>
                </UncontrolledTooltip>
            </div>
        );
    };

    const menu = ORG_MENU.filter(item => item.visibleFor.includes(user.role));

    return (
        <SidebarShell isOpen={isOpen} toggle={toggle} organization={organization} variant="org">
            <Nav vertical className="px-0">
                {menu.map(({link, icon, menuText, checkEquipmentStatus}, index) => (
                    <NavItem key={index} active={checkActive(link)} className="mb-1">
                        <NavLink to={link} onClick={toggle}
                                 className="nav-link text-white d-flex align-items-center justify-content-between d-md-none">
                            <span className={`fas fa-fw me-2 text-primary ${icon}`}/>
                            <span className="flex-grow-1">{menuText}</span>
                            { checkEquipmentStatus &&  getEquipmentStatus()}
                        </NavLink>
                        <NavLink to={link}  onClick={toggle}
                                 className="nav-link text-white d-none d-md-flex align-items-center justify-content-between">
                            <span className={`fas fa-fw me-2 text-primary ${icon}`} />
                            <span className="flex-grow-1">{menuText}</span>
                            {organization && checkEquipmentStatus &&  getEquipmentStatus()}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
        </SidebarShell>
    );
};

export default OrgSidebar;
